import { Component, OnInit } from '@angular/core';
import { SeoService } from 'src/app/services/seo.service';
import { Meta } from '@angular/platform-browser';
import { ScriptTrustedComponent } from '../_components/script-trusted/script-trusted.component';
import { FeeScheduleComponent } from "../_components/fee-schedule/fee-schedule.component";

@Component({
    selector: 'app-fees',
    templateUrl: './fees.component.html',
    styleUrls: ['./fees.component.scss'],
    imports: [ScriptTrustedComponent, FeeScheduleComponent, FeeScheduleComponent]
})
export class FeesComponent implements OnInit {

  title = "Investing for Catholics Management Fee";

  constructor(private seoservice: SeoService, private meta: Meta) { }

  ngOnInit() {

    this.seoservice.updateTitle(this.title);
  	this.meta.addTag({name: 'keywords', content: 'Investing for Catholics Management Fee, investing fees, IFC investing fees'});
    this.meta.addTag({name: 'description', content: 'Investing for Catholics Management Fee and Mutual Fund Fee.'});
    this.meta.addTag({name: 'author', content: 'Investing for Catholics (IFC)'});
    this.meta.addTag({name: 'robots', content: 'index, follow'});

  }

}
